<template>
    <div v-if="$store.state.showLoginModal" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <button class="close-btn" @click="closeModal">×</button>
        <div class="modal-header">
          <!-- <h2>用户登录</h2> -->
          <el-tabs v-model="$store.state.activeLoginTab" @tab-click="handleClick">
            <el-tab-pane label="登录" name="login">
              <div class="modal-body">
                <form @submit.prevent="handleLogin">
                  <div class="form-group">
                    <label>用户名</label>
                    <div>
                      <el-input
                        v-model="loginForm.account"
                        type="text"
                        :class="{ 'input-error': errors.account }"
                        placeholder="请输入用户名">
                      </el-input>
                      <span v-if="errors.account" class="error-msg">{{ errors.account }}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>密码</label>
                    <div>
                      <el-input 
                        placeholder="请输入密码"
                        v-model="loginForm.password"
                        :class="{ 'input-error': errors.password }"
                        show-password></el-input>
                      <span v-if="errors.password" class="error-msg">{{ errors.password }}</span>
                    </div>
                  </div>
                  
                  <button type="submit" :disabled="isLoading" class="submit-btn">
                    {{ isLoading ? '登录中...' : '登录' }}
                  </button>
                </form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="注册" name="register">
              <div class="modal-body">
                <form @submit.prevent="handleRegister">
                  <div class="form-group">
                    <label>用户名</label>
                    <div>
                      <el-input
                        v-model="registerForm.account"
                        type="text"
                        :class="{ 'input-error': registerErrors.account }"
                        placeholder="请输入用户名">
                      </el-input>
                      <span v-if="registerErrors.account" class="error-msg">{{ registerErrors.account }}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>密码</label>
                    <div>
                      <el-input 
                        placeholder="请输入密码"
                        v-model="registerForm.password"
                        :class="{ 'input-error': registerErrors.password }"
                        show-password></el-input>
                      <span v-if="registerErrors.password" class="error-msg">{{ registerErrors.password }}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>确认密码</label>
                    <div>
                      <el-input 
                        placeholder="请再次输入密码"
                        v-model="registerForm.confirmPassword"
                        :class="{ 'input-error': registerErrors.confirmPassword }"
                        show-password></el-input>
                      <span v-if="registerErrors.confirmPassword" class="error-msg">{{ registerErrors.confirmPassword }}</span>
                    </div>
                  </div>
                  
                  <button type="submit" :disabled="isLoading" class="submit-btn">
                    {{ isLoading ? '注册中...' : '注册' }}
                  </button>
                </form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        loginForm: {
          account: '',
          password: ''
        },
        registerForm: {
          account: '',
          password: '',
          confirmPassword: ''
        },
        errors: {},
        registerErrors: {},
        isLoading: false,
      }
    },
    methods: {
      handleClick(tab) {
        this.$store.commit('SET_ACTIVE_TAB', tab.name)
      },
      closeModal() {
        this.$store.commit('CLOSE_LOGIN_MODAL')
        this.resetForm()
      },
      resetForm() {
        this.loginForm = {
          account: '',
          password: ''
        }
        this.registerForm = {
          account: '',
          password: '',
          confirmPassword: ''
        }
        this.errors = {}
        this.registerErrors = {}
      },
      validateLoginForm() {
        this.errors = {}
        let isValid = true
        
        if (!this.loginForm.account.trim()) {
          this.errors.account = '请输入用户名'
          isValid = false
        }
        
        if (!this.loginForm.password) {
          this.errors.password = '请输入密码'
          isValid = false
        } else if (this.loginForm.password.length < 6) {
          this.errors.password = '密码长度不能少于6位'
          isValid = false
        }
        
        return isValid
      },
      validateRegisterForm() {
        this.registerErrors = {}
        let isValid = true
        
        if (!this.registerForm.account.trim()) {
          this.registerErrors.account = '请输入用户名'
          isValid = false
        }
        
        if (!this.registerForm.password) {
          this.registerErrors.password = '请输入密码'
          isValid = false
        } else if (this.registerForm.password.length < 6) {
          this.registerErrors.password = '密码长度不能少于6位'
          isValid = false
        }
        
        if (!this.registerForm.confirmPassword) {
          this.registerErrors.confirmPassword = '请确认密码'
          isValid = false
        } else if (this.registerForm.password !== this.registerForm.confirmPassword) {
          this.registerErrors.confirmPassword = '两次输入的密码不一致'
          isValid = false
        }
        
        return isValid
      },
      handleLogin() {
        if (!this.validateLoginForm()) return;
        
        this.isLoading = true;
        this.$store.dispatch('login', {
          account: this.loginForm.account,
          password: this.loginForm.password
        }).then(success => {
          if (success) {
            this.$message.success('登录成功');
            this.closeModal();
            if (this.$route.path !== '/') {
              this.$router.push('/')
            }
          } else {
            this.$message.error('用户名或密码错误');
          }
        }).catch(() => {
          this.$message.error('网络错误，请重试');
        }).finally(() => {
          this.isLoading = false;
        });
      },
      handleRegister() {
        if (!this.validateRegisterForm()) return;
        
        this.isLoading = true;
        this.$store.dispatch('register', {
          mobile: this.registerForm.account,
          username: this.registerForm.account,
          password: this.registerForm.password,
          re_password: this.registerForm.confirmPassword
        }).then(success => {
          if (success) {
            this.$message.success('注册成功');
            // 注册成功后自动切换到登录标签页
            this.$store.commit('SET_ACTIVE_TAB', 'login');
            // 自动填充用户名
            this.loginForm.account = this.registerForm.account;
          } else {
            this.$message.error('注册失败，用户名可能已被占用');
          }
        }).catch(() => {
          this.$message.error('网络错误，请重试');
        }).finally(() => {
          this.isLoading = false;
        });
      }
      // async handleSubmit() {
      //   if (!this.validateForm()) return
        
      //   this.isLoading = true
      //   try {
      //     const success = await this.$store.dispatch('login', {
      //       username: this.username,
      //       password: this.password
      //     })
          
      //     if (success) {
      //       this.$message.success('登录成功')
      //       this.closeModal()
      //     } else {
      //       this.$message.error('用户名或密码错误')
      //     }
      //   } finally {
      //     this.isLoading = false
      //   }
      // }
    }
  }
  </script>
  
  <style scoped>
  .el-input__inner:focus {
    border-color: #EA4747;
  }
  .el-tabs__item.is-active{
    color: #EA4747;
  }
  .el-tabs__active-bar{
    background-color:#EA4747
  }
  .el-tabs__item:hover{
    color: #EA4747;
  }
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-container {
    width: 100%;
    max-width: 400px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    animation: modal-fade 0.3s;
    position: relative;
  }
  
  @keyframes modal-fade {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .modal-header {
    padding: 1rem;
    /* border-bottom: 1px solid #eee; */
    /* display: flex; */
    justify-content: space-between;
    align-items: center;
  }
  
  .close-btn {
    font-size: 1.5rem;
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 8px;
    z-index: 99;
  }
  
  .modal-body {
    padding: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: bold;
    width: 60px;
  }
  
  .form-group div {
    width: 70%;
  }
  .form-group .el-input {
    width: 100%;
  }
  
  .input-error {
    border-color: #ff4d4f !important;
  }
  
  .error-msg {
    color: #ff4d4f;
    font-size: 0.8rem;
    display: block;
    margin-top: 0.25rem;
  }
  
  .submit-btn {
    width: 100%;
    padding: 0.75rem;
    background: #EA4747;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    margin-top: 1rem;
    transition: background 0.3s;
  }
  
  .submit-btn:hover {
    background: #EA4747;
  }
  
  .submit-btn:disabled {
    background: #d9d9d9;
    cursor: not-allowed;
  }
  </style>


// WEBPACK FOOTER //
// src/components/LoginDialog.vue